<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "XSNJSL",
  data() {
    return {
      telephone: "",
      url: "",
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      var user = sessionStorage.getItem("user");
      if (user) {
        this.telephone = JSON.parse(user);
      }

      var token = sessionStorage.getItem("login_token");
      if (token) {
        const { data: res } = await this.$http.post("getRedirectUrl", {
          token: token,
          tel: this.telephone
        });
        if (res.flag == "ok") {
          this.url = res.url;
        }
      }

      if (this.url) {
        let htmlAnchorElement = document.createElement('a');
        htmlAnchorElement.href = this.url;
        htmlAnchorElement.click();
        htmlAnchorElement = null;
      }

      sessionStorage.removeItem("login_token");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("url");
    },
    async created() {
      const token = sessionStorage.getItem("login_token");
      if (token) {
        // 直接跳转后端302接口
        window.location.href = "/visitorspring/getRedirectUrl?token=" + token;

        // 跳转后清除 token（可选）
        sessionStorage.removeItem("login_token");
        sessionStorage.removeItem("user");
      } else {
        // 无 token，跳回登录
        this.$router.push("/login");
      }
    },
  }
}
</script>

<style scoped>
</style>